import React from 'react';
import AgentList from '../agentlist/AgentList';
import AlternativeResults from '../alternativeresults/AlternativeResults';
import { AgentStaticTeaser } from '../agentstaticteaser/AgentStaticTeaser';
import { useAppSelector } from '../../store/store';
var SearchResults = function SearchResults() {
  var agentsNotFound = useAppSelector(function (state) {
    return !state.search.totalNumberOfAgents || state.search.totalNumberOfAgents === 0;
  });
  var term = useAppSelector(function (state) {
    var _state$search$alterna;
    return (_state$search$alterna = state.search.alternativeResults) === null || _state$search$alterna === void 0 ? void 0 : _state$search$alterna.term;
  });
  var geoPathUri = useAppSelector(function (state) {
    var _state$search$alterna2;
    return (_state$search$alterna2 = state.search.alternativeResults) === null || _state$search$alterna2 === void 0 ? void 0 : _state$search$alterna2.geoPathUri;
  });
  var searchInProgress = useAppSelector(function (state) {
    return state.search.searchInProgress;
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "background"
  }, /*#__PURE__*/React.createElement("div", {
    className: "content-wrapper padding-none"
  }, agentsNotFound && !searchInProgress ? /*#__PURE__*/React.createElement(AlternativeResults, {
    term: term,
    geoPathUri: geoPathUri
  }) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(AgentStaticTeaser, null), /*#__PURE__*/React.createElement(AgentList, null)))));
};
export default SearchResults;